import { Controller } from '@hotwired/stimulus'
import { formElementData, turboRequest } from '../../../helpers/turbo_helper'

export default class extends Controller {
  connect() {
    addEventListener('input:change', this.searchSelectChange)
  }

  disconnect() {
    removeEventListener('input:change', this.searchSelectChange)
  }

  searchSelectChange = (event) => {
    const id = event.detail.id
    if (id.includes('program_id_input')) {
      this.programChanged(event)
    } else if (['service_record_grid_provider_id_input', 'service_record_grid_slate_id_input'].includes(id)) {
      this.providerOrSlateChanged(event)
    }
  }

  providerOrSlateChanged(event) {
    const urlParams = new URLSearchParams()
    this.turboCall('/admin/org/service_record/grids/rerender_tuples', urlParams)
  }

  programChanged(event) {
    const urlParams = new URLSearchParams()

    const id = event.detail.id
    const match = id.match(/service_record_grid_tuples_attributes_(\d+)_program_id_input/)
    if (match) {
      const index = parseInt(match[1], 10)
      urlParams.append('tuple_index', index)
    }

    this.turboCall('/admin/org/service_record/grids/rerender_tuple', urlParams)
  }

  turboCall(url, urlParams) {
    setTimeout(() => {
      turboRequest(`${url}?${formElementData(this.element, urlParams)}`)
    }, 0)
  }
}
